import styled from "styled-components";
import Col from "antd/lib/col";
import Input from "antd/lib/input";
import Button from "antd/lib/button";
import config from "../../staticConfig";

export const StyledContainer = styled.div`
  min-height: 64px;
  max-width: 757px;
  border-radius: 2px;
  background-color: ${config.themeConfig.mainBackgroundColor};
  margin-top: 24px;
  padding-left: 24px;
`;
export const StyledHeader = styled(Col)`
  padding-top: 11px;
  color: ${config.themeConfig.buttonBackgroundColor};
  //font-family: "PingFang SC";
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
  padding-left: 24px;
  &.edit {
    padding-left: 0px;
  }
`;
export const StyledContent = styled(Col)`
  //text-align: center;
  padding-top: 3px;
  padding-bottom: 13px;
`;
export const StyledInput = styled(Input)`
  border: none;
  padding: 0px;
  color: ${config.themeConfig.buttonBackgroundColor} !important;
  //font-family: "PingFang SC";
  font-size: 14px !important;
  letter-spacing: 0;
  line-height: 20px;
  &.updatedWidth {
    width: 210px;
  }
  border: ${(props: { validationResult: boolean }) =>
    !props.validationResult ? "1px solid #ff0000" : "none"};
  //background-color: inherit;
`;

export const StyledButtonContainer = styled(Col)`
  text-align: right;
  padding-top: 8px;
`;

export const StyledButton = styled(Button)`
  height: 30px;
  width: 120px;
  border-radius: 2px;
  background-color: ${config.themeConfig.buttonBackgroundColor};
  color: #ffffff;
  //font-family: "PingFang SC";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  padding: 0px;
`;

export const StyledErrorMsg = styled.p`
  color: #ff0000;
  //font-family: "PingFang SC";
  font-size: 11px;
  letter-spacing: 0;
  line-height: 22px;
  margin: 0px 0px 0px 21px;
`;
